/* HP Cart Upsell loader — mantém o bundle completo fora da navegação inicial. */
(function () {
  'use strict';

  if (window.__hpCartUpsellLoad) return;

  var loader = document.currentScript;
  var cssUrl = loader && loader.getAttribute('data-hp-cart-upsell-css');
  var scriptUrl = loader && loader.getAttribute('data-hp-cart-upsell-script');
  var loaded = false;

  function load() {
    if (loaded || !cssUrl || !scriptUrl) return;
    loaded = true;

    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = cssUrl;
    stylesheet.setAttribute('data-hp-cart-upsell-resource', 'style');
    document.head.appendChild(stylesheet);

    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.setAttribute('data-hp-cart-upsell-resource', 'script');
    document.head.appendChild(script);
  }

  function hasCartIntent(target) {
    return target && target.closest && target.closest(
      '#cart-icon-bubble, cart-drawer, form[action*="/cart/add"], product-form, [name="add"], .quick-add'
    );
  }

  function loadFromIntent(event) {
    if (hasCartIntent(event.target)) load();
  }

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('active')) load();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) load();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* Volta do checkout (09/10, auditoria do Codex no live): sem BFCache o navegador reabre o HTML
     antigo do carrinho e o pageshow passa antes do bundle existir. Na volta, carregar já e marcar a
     restauração; o bundle ressincroniza o drawer ao iniciar. */
  window.addEventListener('pageshow', function (event) {
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!event.persisted && (!nav || nav.type !== 'back_forward')) return;
    window.__hpCartUpsellRestored = true;
    load();
  });

  /* Bloco 3.1 (12/10): o botão "Aplicar oferta" do aviso de aceite não confirmado grava esta chave e recarrega a
     página. Na página recarregada o bundle só viria com o drawer aberto: o loader carrega o bundle e reabre o drawer,
     e a reconciliação do bundle aplica a oferta. Vale uma vez, por 1 minuto. */
  function reopenAfterReload() {
    var at = null;
    try {
      at = window.sessionStorage.getItem('hp-cart-reabrir');
      if (at) window.sessionStorage.removeItem('hp-cart-reabrir');
    } catch (e) {}
    if (!at || !(Date.now() - Number(at) < 60000)) return;
    load();
    var open = function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    };
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(open);
    else open();
  }

  window.__hpCartUpsellLoad = load;
  document.addEventListener('pointerdown', loadFromIntent, { capture: true, passive: true });
  document.addEventListener('focusin', loadFromIntent, true);
  document.addEventListener('submit', loadFromIntent, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer, { once: true });
    document.addEventListener('DOMContentLoaded', reopenAfterReload, { once: true });
  } else {
    observeDrawer();
    reopenAfterReload();
  }
})();
